import { useState, useEffect } from "react";
// material
import { Box, Card, Container, Typography, Tooltip } from "@mui/material";
// components
import Scrollbar from "../table/Scrollbar";
import ListToolbar from "../table/ListToolbar";
import TableView from "../Table";
import {
  parseCurrency,
  parseDateTime,
  getMonday,
  formatDateFilter,
} from "../../utils/tableFunctions";
import {
  getReportFilterParam,
  getReportList,
  getReportCSV,
} from "../../services/reports";
import moment from "moment";
import { Log, getNextPage } from "../../services/services";

import {
  DateRangeType,
  InputType,
  MinMaxType,
  MultiCheckboxesType,
  MultiSelect,
} from "../table/Filter";
import CircularLoader from "../circularLoader";

// ----------------------------------------------------------------------

export default function TransactionList() {
  const [transaction, setTransaction] = useState();
  const [next, setNext] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [tableData, setTableData] = useState();
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState();
  const [fParams, setFParams] = useState({});

  // ------------------ filterStuffies --------------------//
  const [fMerchantName, setFMerchantName] = useState([]);
  const [fDate, setFDate] = useState([getMonday(), moment()]);
  const [fPaymentHost, setFPaymentHost] = useState([]);
  const [reset, setReset] = useState(false);
  const filter = {
    payment_host: fPaymentHost,
    merchant_name_list: fMerchantName,
    start_datetime: formatDateFilter(fDate[0], "start"),
    end_datetime: formatDateFilter(fDate[1], "end"),
  };

  const filterComponents = () => {
    return (
      fParams && (
        <Container sx={{ overflowX: "auto" }}>
          <Box sx={{ mt: 3 }}>
            <Box sx={{ height: 15 }} />
            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Merchant Name
            </Typography>
            <MultiSelect
              options={fParams.merchant_name?.map((name) => ({
                value: name ? name : "",
                label: name ? name : "",
              }))}
              setSelectedValues={setFMerchantName}
              selectedValues={fMerchantName}
              reset={reset}
            />
            <Box sx={{ height: 15 }} />
            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Payment Host
            </Typography>
            <MultiSelect
              options={fParams.payment_host?.map((name) => ({
                value: name ? name : "",
                label: name ? name : "",
              }))}
              setSelectedValues={setFPaymentHost}
              selectedValues={fPaymentHost}
              reset={reset}
            />
            <Box sx={{ height: 15 }} />

            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Date
            </Typography>
            <DateRangeType date={fDate} setDate={setFDate} reset={reset} />
            <Box sx={{ height: 15 }} />

            {/* <Typography variant="subtitle1" sx={{ my: 1 }}>
              Payment Brand
            </Typography>
            <MultiCheckboxesType
              items={fParams.payment_brand}
              checkedValues={fBrand}
              setCheckedValues={setFBrand}
              reset={reset}
            />
            <Box sx={{ height: 15 }} />

            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Payment Method
            </Typography>
            <MultiCheckboxesType
              items={fParams.payment_method}
              checkedValues={fMethod}
              setCheckedValues={setFMethod}
              reset={reset}
            />
            <Box sx={{ height: 15 }} />

            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Base Currency
            </Typography>
            <MultiCheckboxesType
              items={fParams.base_currency}
              checkedValues={fCurrency}
              setCheckedValues={setFCurrency}
              reset={reset}
            />
            <Box sx={{ height: 15 }} />

            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Base Amount
            </Typography>
            <MinMaxType
              minVal={fParams.min_base_amount}
              maxVal={fParams.max_base_amount}
              setValue={setFBaseAmt}
              value={fBaseAmt}
              reset={reset}
            />
            <Box sx={{ height: 15 }} />

            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Transaction Amount
            </Typography>
            <MinMaxType
              minVal={fParams.min_transaction_amount}
              maxVal={fParams.max_transaction_amount}
              setValue={setFTransactionAmt}
              value={ftransactionAmt}
              reset={reset}
            />
            <Box sx={{ height: 15 }} /> */}
          </Box>
        </Container>
      )
    );
  };

  const onFilterSubmit = () => {
    Log.info('Click button [Apply Filter] - Search Report list', filter);
    getReportList(setTransaction, null, false, filter);
  };

  // ------------------ end of filter stuffies --------------------//

  useEffect(() => {
    if (reset) setReset(false);
  }, [reset]);

  const getCSVData = async () => {
    const data = await getReportCSV(filter);
    return data;
  };

  const getNext = async () => {
    if (!next) return;
    const res = await getNextPage({
      url: next,
      filter: filter,
    });
    let newRows = formatData(res);
    setTableData((old) => [...old, ...newRows]);
    setNext(res.next ? res.next : false);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  useEffect(() => {
    if (!loaded) {
      getReportFilterParam(setFParams);
      getReportList(setTransaction, setLoaded, false, filter);
    }
  }, [loaded]);

  const formatData = (input) => {
    let tableData = [];
    input.results.forEach(
      ({
        currency,
        cycle_range,
        id,
        merchant,
        payment_host,
        report_date,
        report_number,
        revision_number,
        security_balance,
        stt_report_name,
      }) => {
        tableData.push({
          id: id,
          merchant_name: merchant && merchant.name,
          host: payment_host && payment_host.name,
          report_number: report_number && report_number,
          date: report_date && report_date,
          revision_number: revision_number && report_number,
        });
      }
    );
    return tableData;
  };

  useEffect(() => {
    if (transaction) {
      setTableData(formatData(transaction));
      setNext(transaction.next);
    }
  }, [transaction]);

  return (
    <Container style={{ paddingLeft: 0, paddingRight: 0 }}>
      {loaded ? (
        <Card>
          <ListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            date={fDate}
            filter={true}
            loaded={loaded}
            type="reports"
            filterFunction={filterComponents}
            onFilterSubmit={onFilterSubmit}
            setReset={setReset}
            csv={false}
            getCSVData={getCSVData}
          />
          <Scrollbar>
            <TableView
              rows={tableData}
              link={`/3/app/details/reports`}
              getNext={getNext}
              count={transaction.count}
              query={filterName}
            />
          </Scrollbar>
        </Card>
      ) : (
        <CircularLoader />
      )}
    </Container>
  );
}
